/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Mode_AlignInputs */

const cs_property_ai_mode_align = /** @type {(inputs: Property_Ai_Mode_AlignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Srovnání / vyrovnání`)
};

const en_property_ai_mode_align = /** @type {(inputs: Property_Ai_Mode_AlignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Align / straighten`)
};

/**
* | output |
* | --- |
* | "Align / straighten" |
*
* @param {Property_Ai_Mode_AlignInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_mode_align = /** @type {((inputs?: Property_Ai_Mode_AlignInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Mode_AlignInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_mode_align(inputs)
	return cs_property_ai_mode_align(inputs)
});